import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullSavedCard from "../fragments/fullSavedCard"

const query = gql`
  query SavedCardsForProvider($provider: PaymentProvider!) {
    savedCards(provider: $provider) {
      results {
        ...fullSavedCard
      }
    }
  }
  ${fullSavedCard}
`

export const toString = query.loc.source.body

export const savedCardsKey = getQueryNames(query)[0]

export default query
